import React from "react";
import LeftFilters from "./LeftFilter";
import GlobalSearch from "../../../components/Search";
import { useSelector } from "react-redux";
import ComplianceYear from "../../LeadCompliance/components/Header/ComplianceYear";
import RightFilters from "../../LeadCompliance/components/Filters/RightFilters";
import MailerToSend from "../../LeadCompliance/components/Header/Download/MailerToSend";
import MailerForReview from "../../LeadCompliance/components/Header/Download/MailerForReview";
import { downloadPendingMailerFireNotice } from "../../../sevices/fireNoticeApi";
import PrimaryButton from "../../../components/Button/Button";
import { Chip } from "@mui/material";
import { isAdmin, isSelfService } from "../../../utils/helpers";

function Filters({ building, client, isFilterHide = false }) {
  const statusCount = useSelector((state) => state.compliance.count);
  const is_self_service = isSelfService();
  
  return (
    <>
      <div className="tickets-filter bg-white">
        <div className={`d-flex align-items-center justify-content-space-between ${!isFilterHide ? "filter-border" : ""} filter-paddings filter-bottom-paddings`}>
          <ComplianceYear name={"Compliance Year"} />
          <div className="d-flex">
            <RightFilters complianceType={"fire_notice"} />
            {(isAdmin() || is_self_service) && (
              <>
                {isAdmin() && <MailerToSend
                  btnTitle={"Survey to Send"}
                  downloadCallback={downloadPendingMailerFireNotice}
                  pdfName={"annual-report-survey-to-send.pdf"}
                />}
                <MailerForReview
                  btnTitle={"Survey for Review"}
                  downloadCallback={downloadPendingMailerFireNotice}
                  pdfName={"annual-report-fire-notice-for-review.pdf"}
                />
              </>
            )}
          </div>
        </div>
        {!isFilterHide && <div className="d-flex align-items-center justify-content-space-between filter-top-paddings">
          <LeftFilters />
          <PrimaryButton
            variant="contained"
            className={`capitalize`}
            disabled={true}
          >
            Returned Notices
            <Chip
              label={
                (statusCount?.completed ?? 0) + (statusCount?.in_process ?? 0)
              }
              size="small"
              color="success"
              sx={{ backgroundColor: "#11b50c66 !important" }}
              className="ml-1"
            />
          </PrimaryButton>
        </div>}
      </div>
    </>
  );
}

export default Filters;
